import React, { useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Button,
  Typography,
  Grid,
} from "@mui/material";
import { CheckCircleOutline as CheckCircleOutlineIcon } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useStyles } from "../../../theme/appStyles";
import useIsMobile from "../../../Core/hook/useIsMobile";

interface PopupMessageProps {
  message: string;
}

const PopupMessage: React.FC<PopupMessageProps> = ({ message }) => {
  const [openDialogMissing, setOpenDialogMissing] = useState<boolean>(true);
  const navigate = useNavigate();
  const classes = useStyles();
  const isMobileRes = useIsMobile();

  return (
    <Dialog
      open={openDialogMissing}
      onClose={() => setOpenDialogMissing(false)}
      sx={{ padding: 5, minWidth: 450 }}
    >
      <Grid className={isMobileRes ? classes.DialogMobile :classes.Dialog}>
        <Grid
          container
          justifyContent={"space-between"}
          spacing={5}
          sx={{ borderBottom: 2, padding: 2 }}
          className={classes.titleGrid}
        >
          <Grid
            item
            lg={12}
            md={12}
            sm={12}
            xs={12}
            pt={2}
            alignContent={"center"}
          >
            <Typography className={classes.cardTitle}>Message</Typography>
          </Grid>
        </Grid>

        <DialogContent>
          <DialogContentText sx={{ pt: 3 }}>
            <Typography className={classes.bodyDialog} pb={2}>
              {message}
            </Typography>
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => {
              navigate("/dashboard");
              setOpenDialogMissing(false);
            }}
            variant="contained"
            startIcon={<CheckCircleOutlineIcon />}
            className={classes.addButton}
          >
            Check
          </Button>
        </DialogActions>
      </Grid>
    </Dialog>
  );
};

export default PopupMessage;
